import { Box, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { useStyles } from './exam-session-selection.style';
import { ExamSessionOption } from './use-exam-session-selection.hook';
import { useTranslation } from '@pruforce/common-adminweb-sdk';
import { useSelector } from 'react-redux';
import { selectExamModeMap } from 'src/app/modules/Config/_redux/configSlice';

interface ExamSessionListProps {
  options: ExamSessionOption[];
  value: string;
  onChange: (sessionValue: ExamSessionOption) => void;
}

export const ExamSessionList = ({ options, value, onChange }: ExamSessionListProps) => {
  const t = useTranslation();
  const examModeMap: Record<string, string> = useSelector(selectExamModeMap);
  const { classes, cx } = useStyles();

  return (
    <RadioGroup
      value={value}
      className={classes.sessionGroup}
      aria-label="exam session selection"
    >
      {options.map((option) => {
        const selected = value === option.value;
        return (
          <FormControlLabel
            key={`${option.value}-${option.label}`}
            value={option.value}
            control={
              <Radio
                color="secondary"
                size="small"
                checked={selected}
                onChange={() => onChange(option)}
              />
            }
            label={(
              <Box className={classes.sessionOptionContent}>
                <Box className={classes.sessionDetails}>
                  <Typography className={classes.sessionDate}>
                    {option.dateText}
                  </Typography>
                  <Typography variant="body2" className={classes.sessionMeta}>
                    {option.timeText} · {option.examMode ? t(examModeMap[option.examMode]) : option.examMode}
                  </Typography>
                </Box>
                <Typography className={classes.sessionQuota}>
                  {t('recruitment.exam.examRemainingQuota')}: {option.remainingQuota}/{option.quota}
                </Typography>
              </Box>
            )}
            className={cx(classes.sessionOption, selected && classes.sessionOptionSelected)}
            classes={{ label: classes.sessionOptionLabel }}
          />
        );
      })}
    </RadioGroup>
  );
};
